import {
  regexEmail,
  regexName,
  regexPhone,
  regexDate,
} from "../../helpers/regex";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { createRecordInDb } from "../../controllers/createRecord";
import { IRecordCreate } from "../../interfaces/interfaces";
import { useRecords } from "../../hooks/useRecords";
import "./FormRecord.css";

const SignupSchema = Yup.object().shape({
  name: Yup.string()
    .required("Se requiere nombre.")
    .min(4, "Se requieren 4 caracteres como mínimo.")
    .max(12, "Se aceptan hasta 12 caracteres.")
    .matches(regexName, "Solo se aceptan letras."),
  email: Yup.string()
    .required("Se requiere email.")
    .min(6, "Se requieren 6 caracteres como mínimo.")
    .max(35, "Se aceptan hasta 35 caracteres.")
    .matches(regexEmail, "Solo se aceptan emails."),
  phone: Yup.string()
    .required("Se requiere teléfono.")
    .min(8, "Se requieren 9 dígitos como mínimo.")
    .max(9, "Se aceptan hasta 9 dígitos.")
    .matches(regexPhone, "Solo se aceptan números."),
  date: Yup.string()
    .required("Se requiere fecha.")
    .matches(regexDate, "Solo fecha con formato dd/mm/yyyy."),
});

const createOneRecord = async (
  dataNewRecord: IRecordCreate,
  actions: any,
  addRecord: any
) => {
  let newRecord = await createRecordInDb(dataNewRecord);

  if (newRecord) {
    window.alert("The record was created!");

    actions.resetForm();

    addRecord(newRecord);
  } else {
    window.alert("The record was not created");
  }
};

const FormRecord: React.FC<any> = () => {
  const { addRecord } = useRecords();

  const initialValues: IRecordCreate = {
    name: "",
    email: "",
    phone: "",
    date: new Date().toLocaleDateString(),
  };

  return (
    <div className="Form-box">
      <Formik
        initialValues={initialValues}
        onSubmit={(values, actions) => {
          createOneRecord(values, actions, addRecord);
        }}
        validationSchema={SignupSchema}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="Input-box">
              <label htmlFor="name">Nombre</label>
              <Field id="name" name="name" placeholder="Nombre" />
            </div>
            <div className="Input-error-box">
              {errors.name && touched.name ? <div>{errors.name}</div> : null}
            </div>
            <div className="Input-box">
              <label htmlFor="email">Email</label>
              <Field id="email" name="email" placeholder="email@email.com" />
            </div>
            <div className="Input-error-box">
              {errors.email && touched.email ? <div>{errors.email}</div> : null}
            </div>
            <div className="Input-box">
              <label htmlFor="phone">Teléfono</label>
              <Field
                id="phone"
                name="phone"
                type="tel"
                placeholder="123 456 789"
              />
            </div>
            <div className="Input-error-box">
              {errors.phone && touched.phone ? <div>{errors.phone}</div> : null}
            </div>
            <div className="Button-box">
              <button type="submit">Guardar</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FormRecord;
